import axios from 'axios';
import SearchResult from '../models/SearchResult';
import SearchResultMapper from '../mappers/SearchResultMapper';

export default class SearchService {
    public async searchContent(keywords: string, language: string, persona: string, numberOfItems : number, page: number, summaryLength: number) : Promise<SearchResult> {
        let api = axios.create({
            baseURL: ''
        });
        const data : any = await api.get('/Search/Search?keywords=' + keywords + '&personaID=' + persona + '&language=' + language + '&numberofItems=' + numberOfItems + '&page=' + page + '&summaryLength=' + summaryLength);

        const result: SearchResult = SearchResultMapper.map(data.data);

        return result;
    }
}